import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import type { OutlineNodeDto } from '../../api/queries/outlines';

const STATUS_COLORS: Record<string, string> = {
  not_started: '#9e9e9e',
  in_progress: '#2196f3',
  drafted: '#ff9800',
  revised: '#4caf50',
  complete: '#8bc34a',
};

interface OutlineSceneCardProps {
  node: OutlineNodeDto;
  isSelected: boolean;
  onClick: () => void;
}

export function OutlineSceneCard({
  node,
  isSelected,
  onClick,
}: OutlineSceneCardProps) {
  const statusColor = node.status ? STATUS_COLORS[node.status] : undefined;

  return (
    <Card
      variant={isSelected ? 'elevation' : 'outlined'}
      sx={{
        border: isSelected ? '2px solid' : undefined,
        borderColor: isSelected ? 'primary.main' : undefined,
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ mb: 0.5 }}
          >
            {statusColor && (
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: statusColor,
                  flexShrink: 0,
                }}
              />
            )}
            <Typography variant="subtitle2" noWrap sx={{ flex: 1 }}>
              {node.name}
            </Typography>
            {node.nodeType && (
              <Chip
                label={node.nodeType}
                size="small"
                sx={{ height: 18, fontSize: '0.65rem' }}
              />
            )}
          </Stack>
          {node.location && (
            <Typography variant="caption" color="text.secondary" noWrap>
              {node.location}
            </Typography>
          )}
          {node.synopsis && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                mt: 0.5,
              }}
            >
              {node.synopsis}
            </Typography>
          )}
          <Stack
            direction="row"
            spacing={0.5}
            sx={{ mt: 0.5, flexWrap: 'wrap' }}
          >
            {node.mood && (
              <Chip
                label={node.mood}
                size="small"
                variant="outlined"
                sx={{ height: 18, fontSize: '0.6rem' }}
              />
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
